// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"488":"axiom","532":"styles","592":"common","736":"vendor"}[chunkId] || chunkId) + "." + {"488":"58034f2914300f173826","532":"8bbf4a81c065a9b9699d","569":"86d0c80464ece9bcad8f","592":"540a187630423cb79047","736":"2ae27b939d094671ccc4"}[chunkId] + ".js";
};